export default "/react/logoJagaJam-94901f94.png";